module.exports = __webpack_public_path__ + "static/media/icon-vomi.281507b2.svg";